"use strict";

exports.__esModule = true;
exports.default = shuffle;
var _sample = _interopRequireDefault(require("./sample.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Shuffle a collection.
function shuffle(obj) {
  return (0, _sample.default)(obj, Infinity);
}